import { FormControl, TextField } from "@mui/material";
import { Controller, useFormState } from "react-hook-form";

export function TextFormField({
  name,
  multiline = false,
  disabled = false,
  rows,
  minRows,
  maxRows,
  valueRegex,
}: {
  name: string;
  multiline?: boolean;
  disabled?: boolean;
  rows?: number;
  minRows?: number;
  maxRows?: number;
  valueRegex?: RegExp;
}) {
  const { errors } = useFormState();
  const error = errors[name];

  return (
    <FormControl sx={{ height: "100%" }} fullWidth>
      <Controller
        name={name}
        render={({ field }) => (
          <TextField
            multiline={multiline}
            fullWidth
            disabled={disabled}
            sx={{
              height: "100%",
            }}
            InputProps={{
              style: {
                height: "100%",
                borderRadius: "5px",
              },
            }}
            rows={rows}
            minRows={minRows}
            maxRows={maxRows}
            error={!!error}
            helperText={error && `${error?.message}`}
            {...field}
            value={field.value ?? ""}
            onChange={(event) => {
              const value = event.target.value;

              if (valueRegex && value !== "" && !valueRegex.test(value)) {
                return;
              }

              field.onChange(event);
            }}
          />
        )}
      />
    </FormControl>
  );
}
